import React, { FC } from 'react'

// Components
import { Modal, ContactForm } from 'components/shared'

// Styles
import { makeStyles, Theme, Box, Typography } from '@material-ui/core'

// Images
import { IUser } from '../../types'

interface ContactProps {
  showModal: boolean
  onCloseModal: () => void
  user?: IUser | null
  demo?: string
  setErrorMessage: (message: string | null) => void
  setSuccessMessage: (message: string | null) => void
}

export const Contact: FC<ContactProps> = ({
  showModal,
  onCloseModal,
  user,
  demo,
  setErrorMessage,
  setSuccessMessage
}) => {
  const classes = useStyles()

  return (
    <Modal open={showModal} onClose={onCloseModal} closeFn={onCloseModal} classes={{ container: classes.modal }}>
      <Box className={classes.root}>
        <Typography component='h2' variant='h3' className={classes.title} color='textPrimary' gutterBottom>
          Talk to an expert.
        </Typography>
        <Typography className={classes.description}>
          Please answer a few questions to help us connect you with the right specialist.
        </Typography>
        <ContactForm
          setShowModal={onCloseModal}
          isHelpRequest={false}
          setSuccessMessage={setSuccessMessage}
          setErrorMessage={setErrorMessage}
          demo={demo}
          messageHelper='Please let us know what we can do to serve your needs.'
          user={user}
        />
      </Box>
    </Modal>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '560px',
    borderRadius: 0,
    position: 'relative',
    backgroundColor: '#ffffff',
    overflow: 'auto',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '20px'
    }
  },
  description: {
    marginBottom: 25
  },
  modal: {
    maxWidth: '560px !important',
    minWidth: '560px !important',
    maxHeight: 573,
    padding: '50px 45px !important'
  },
  title: {
    fontSize: 28,
    marginBottom: 15
  },
  closeButton: {
    position: 'absolute',
    top: '0',
    right: '0'
  }
}))
